import MainRoutes from "./app/routes";
import NavigationScroll from "./components/NavigationScroll";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ToastContainer, Zoom } from "react-toastify";
import { api } from "./app/api";
import { setUser } from "./app/reducers/user";
import Loader from "./components/Loader";
import { useLocation } from "react-router-dom";
import MessagePopup from "components/message/MessagePopup";
import { MessageProvider } from "components/message/message";
import "react-toastify/dist/ReactToastify.css";
import GlobalDropdown from "components/dropdown/GlobalDropdown";
import { DropdownProvider } from "components/dropdown/DropdownContext";

const titles = {
  en: "Roomster - booking engine for your hotel",
  ru: "Roomster - модуль бронирования для вашего отеля",
  ua: "Roomster - модуль бронювання для вашого готеля",
};

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  const getUserData = async (force = false) => {
    if ((pathname !== "/reset-password" && pathname !== "/sign-in") || force) {
      setLoading(true);

      try {
        const user = await api.get("employee/me");
        dispatch(setUser(user.data));
      } catch (e) {}
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!localStorage.locale) {
      localStorage.setItem("locale", "en");
    }
    document.title = titles[localStorage.locale] || titles.en;

    getUserData();
    window.getUserData = getUserData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <Loader />;

  return (
    <NavigationScroll>
      <MessageProvider>
        <DropdownProvider>
          <ToastContainer autoClose={800} closeOnClick transition={Zoom} position={"top-center"} closeButton={false} hideProgressBar pauseOnHover />
          <MessagePopup />
          <MainRoutes />
          <GlobalDropdown />
        </DropdownProvider>
      </MessageProvider>
    </NavigationScroll>
  );
}

export default App;
